import React  from 'react'
import DropDown from '../dropdown';
import { Promotions } from '../../../api/services/next';

export const PromotionsDropDown = ({...props}) => {
    return <DropDown search={true} api={Promotions.GetPromotions} textField="Name" valueField="Id"  {...props}/>
}

export default PromotionsDropDown